let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7EQgJ")).then(() => parcelRequire('9wHM1'));